import { NS_CONFIGURATION, PROJECT, EDITOR, SPRINT } from 'redux/constants';
import { action, createType, SYNC, ASYNC } from 'redux-create-type';

export const {
  INIT,
  INVALIDATE,
  SET_TEAM,
  REFRESH,
  EDIT,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, SPRINT)({
    INIT: ASYNC,
    INVALIDATE: ASYNC,
    SET_TEAM: SYNC,
    REFRESH: SYNC,
    EDIT: SYNC,
  });

export const init = {
  begin: ({ projectId }) => action(INIT.BEGIN, { projectId }),
  end: ({ sprintList, teamOptions, selectedTeam }) => action(INIT.END, { sprintList, teamOptions, selectedTeam }),
};
export const invalidate = {
  begin: () => action(INVALIDATE.BEGIN),
  end: ({ items }) => action(INVALIDATE.END, { items }),
};
export const setTeam = teamId => action(SET_TEAM, { teamId });
export const refresh = () => action(REFRESH);
export const edit = ({ sprintId }) => action(EDIT, { sprintId });




// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/sprint/actions.js